import App from 'app/app.js';

export const flowMap = {
  SIGN_IN: 'SIGN_IN',
  GUEST_LT_CODE: 'GUEST_LT_CODE',
  GUEST_PORTRAIT_ID: 'GUEST_PORTRAIT_ID',
  GUEST_PICTURE_DAY_ID: 'GUEST_PICTURE_DAY_ID',
  GUEST_STUDENT_ID: 'GUEST_STUDENT_ID',
  FMPD_SCHOOL_FORM: 'FIND_MY_PICTURE_DAY_SCHOOL_FORM',
  FMPD_STUDENT_FORM: 'FIND_MY_PICTURE_DAY_STUDENT_FORM'
};

const elementNamesMap = {
  signInForm: 'signInForm',
  guestLoginBanner: 'guestLoginBanner',
  startByEmailDesc: 'startByEmailDesc',
  startByCodeDesc: 'startByCodeDesc',
  activeLTCodeTab: 'activeLTCodeTab',
  activeStudentIdTab: 'activeStudentIdTab',
  studentIdForm: 'studentIdForm',
  guestEmailForm: 'guestEmailForm',
  findMyPictureForm: 'findMyPictureForm',
  portraitIdForm: 'portraitIdForm',
  pictureDayIdForm: 'pictureDayIdForm'
};

const orderFormFlowMap = {
  SIGN_IN: [elementNamesMap.startByEmailDesc, elementNamesMap.studentIdForm, elementNamesMap.signInForm],
  GUEST_LT_CODE: [
    elementNamesMap.signInForm,
    elementNamesMap.guestLoginBanner,
    elementNamesMap.startByCodeDesc,
    elementNamesMap.guestEmailForm,
    elementNamesMap.activeLTCodeTab
  ],
  GUEST_STUDENT_ID: [
    elementNamesMap.signInForm,
    elementNamesMap.guestLoginBanner,
    elementNamesMap.startByCodeDesc,
    elementNamesMap.guestEmailForm,
    elementNamesMap.activeStudentIdTab
  ],
  GUEST_PORTRAIT_ID: [elementNamesMap.portraitIdForm],
  GUEST_PICTURE_DAY_ID: [elementNamesMap.pictureDayIdForm]
};

function OrderFormService(AnalyticsService) {
  this.currentFlow = flowMap.SIGN_IN;
  this.teacherNameStatus = false;

  this.changeFlowToLifetouchCode = function () {
    AnalyticsService.addAdobeFormLoadEvent(AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_CODE);
    this.currentFlow = flowMap.GUEST_LT_CODE;
  };

  this.changeFlowToPortraitId = function () {
    this.currentFlow = flowMap.GUEST_PORTRAIT_ID;
  };

  this.changeFlowToPictureDayId = function () {
    AnalyticsService.addAdobeFormLoadEvent(AnalyticsService.ADOBE_FORM_IDS.GUEST_LOGIN_PICTUREID_DETAIL);
    this.currentFlow = flowMap.GUEST_PICTURE_DAY_ID;
  };

  this.changeFlowToStudentId = function () {
    this.currentFlow = flowMap.GUEST_STUDENT_ID;
  };

  this.goToSignIn = function () {
    this.currentFlow = flowMap.SIGN_IN;
  };

  this.setTeacherNameStatus = function (status) {
    this.teacherNameStatus = status;
  };

  this.getTeacherNameStatus = function () {
    return this.teacherNameStatus;
  };

  this.getCurrentFlow = function () {
    return orderFormFlowMap[this.currentFlow];
  };

  this.getElementsNamesMap = function () {
    return elementNamesMap;
  };
}

App.service('OrderFormService', ['AnalyticsService', OrderFormService]);
